var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPayoutSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12476 2.54039C7.87092 2.28655 7.45936 2.28655 7.20552 2.54039L3.53901 6.20689C3.28517 6.46073 3.28517 6.87229 3.53901 7.12613C3.79285 7.37997 4.20441 7.37997 4.45825 7.12613L7.01514 4.56925V13.265C7.01514 13.624 7.30615 13.915 7.66514 13.915C8.02412 13.915 8.31514 13.624 8.31514 13.265V4.56924L10.872 7.12613C11.1259 7.37997 11.5374 7.37997 11.7913 7.12613C12.0451 6.87229 12.0451 6.46073 11.7913 6.20689L8.12476 2.54039Z",
    fill: "url(#paint0_linear_7640_2300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7640_2300",
    x1: 7.66371,
    y1: 3.00003,
    x2: 7.66371,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#298E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F5E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPayoutSuccess);
export default __webpack_public_path__ + "static/media/ArrowPayoutSuccess.11d4af98c9aeae4e8e89be0e98be3776.svg";
export { ForwardRef as ReactComponent };